import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ReactComponent as AuthImage } from 'core/assets/images/auth.svg';
import Login from './components/Login';

import './styles.scss';

const Auth = () => (
    <div className="auth-container">
        <div className="auth-info">
            <h1 className="auth-info-title">
                Divulgue seus produtos <br /> no InstaCatalog
            </h1>

            <p className="auth-info-subtitle">
                Faça parte do nosso catálogo de divulgação e <br /> aumente a venda dos seus produtos e serviços.
            </p>
            <AuthImage />
        </div>
        <div className="auth-content">
            <Routes>
                <Route path="login" element={<Login />} />
                <Route path="register" element={<h1>Cadastro</h1>} />
                <Route path="recover" element={<h1>Recuperar</h1>} />
            </Routes>
        </div>

    </div>
);

export default Auth;